


























import CompanyUserRequired from "../CompanyRequired";
import {Component, Prop} from "vue-property-decorator";
import {HseGuideline} from "@/modules/models";
import EllipsisScroller from "@/components/EllipsisScroller.vue";
import rd from "@/modules/vRoutedefs";

@Component({
  components: {
    "at-ellips": EllipsisScroller,
  }
})
export default class HseGuidelineCard extends CompanyUserRequired {
  @Prop()
  guideline!: HseGuideline;

  locationTo(locid: number) {
    return {name: rd.locations.location.name, params: {locationId: `${locid}`}};
  }
}
